import React, { Component } from 'react'
import { Card } from 'antd'
import { IntegrationConsumer, IntegrationProvider } from '../../../../context/IntegrationContext'
import DefinitionsListOnNetwork from './list'

export default class DefinitionsListTab extends Component<{network_uuid}> {

  private integrationFilterDispatchOptions = {
    search: {
      deleted: false,
      active: true,
    },
    options: {
    }
  } as const

  integrationListSearch = Object.assign({}, this.integrationFilterDispatchOptions)

  handleFiltersSubmit = (payload: any) => {
    if (payload && payload.search) {
      this.integrationListSearch = {
        ...this.integrationListSearch,
        search: payload.search
      }
    }
  }


  render() {
    const { permissions, history }: any = this.props

    return (
        <IntegrationProvider>
        <IntegrationConsumer>
            {({
                    fetching,
                    integrations,
                    pagination,
                    requestIntegrationDefinitionsList,
                  }) => {

                    return (
                      <>
            <Card title="List of Definitions">
                <DefinitionsListOnNetwork
                loading={fetching}
                network_uuid={this.props.network_uuid}
                integrations={integrations}
                pagination={pagination}
                permissions={permissions}
                history={history}
                searchOptions={this.integrationListSearch}
                loadIntegrations={requestIntegrationDefinitionsList}
                />
            </Card>
                </>
            )
            }}
        </IntegrationConsumer>
        </IntegrationProvider>
    )
  }
}
